module.exports = __webpack_public_path__ + "src/assets/img/cloudy.29833665.svg";